
import { GA } from '@/api/analytics'
import { db } from '@/api/firebase'
import router from '@/router'
import { defineComponent, computed, PropType, reactive, ref, onMounted } from 'vue'

export default defineComponent({
  name: 'MigrationRoute',
  setup() {
    const loading = ref(true)

    onMounted(async () => {
      const oldRouteId = router.currentRoute.value.params.id as string
      const route = await db.collection('routes').where('migrationId', '==', oldRouteId).limit(1).get()
      if (route.docs.length && route.docs[0].exists) {
        router.push('/r/' + route.docs[0].id)
        GA('migration', { status: 'redirect' })
      } else {
        loading.value = false
        GA('migration', { status: 'modal' })
      }
    })

    return { loading }
  }
})
